import gql from 'graphql-tag'
import { EntityFields } from '..'
import { EmployeeFragment } from '../hr'
import {
  SupportDocumentTypeFragment,
  TransferTypeFragment,
  ProcessStatusFragment,
  ClosingReasonFragment,
} from '../settings'

export const BasePurchaseOrderFragment = gql`
  fragment BasePurchaseOrder on purchase_purchase_order {
    ${EntityFields}
    agreedAmount:agreed_amount
  }
`

export const PurchaseOrderFragment = gql`
  ${BasePurchaseOrderFragment}
  ${EmployeeFragment}
  ${ProcessStatusFragment}
  ${ClosingReasonFragment}
  ${TransferTypeFragment}
  ${SupportDocumentTypeFragment}
  fragment PurchaseOrder on purchase_purchase_order {
    ...BasePurchaseOrder
    validator {
      ...Employee
    }
    status {
      ...ProcessStatus
    }
    closingReason: closing_reason {
      ...ClosingReason
    }
    transferType: transfer_type {
      ...TransferType
    }
    supportDocumentType: support_document_type {
      ...SupportDocumentType
    }
  }
`
